import { useEffect, useState } from 'react';
import { usePAChecklistFollowUp } from '../pa_checklist_followup_context';
import { Form } from 'react-bootstrap';
import styles from '../pa_checklist_followup.module.scss'
import SelectInput from '../../../Misc/SelectInput/SelectInput';
import StatusSugerido from './tinyComps/status_sugerido';
import TabInfoComp from './tinyComps/tab_info_tab_comp';

const PAChecklistFollowUpFinalTab = () => {
  const { itemSelecionado, formularioFinalizacao, setFormularioFinalizacao, listaStatus, listaDestino, listaPendenciaUm, listaPendenciaDois, dadosResultadoFinal, isAdmin, usuarioGestaoFup } = usePAChecklistFollowUp();

  const { statusSugerido, statusChecklist, possuiDirecionamento2Q } = dadosResultadoFinal;
  const [versaoAba, setVersaoAba] = useState(0);
  const [listaStatusFiltrada, setListaStatusFiltrada] = useState([]);

  useEffect(() => {
    const { revisao_ok, conferencia_caixa_ok, analise_ok, prova_de_roupa_ok, finalizacao_ok, pendente } = itemSelecionado;
    if (!revisao_ok || !conferencia_caixa_ok || !analise_ok || !prova_de_roupa_ok) return setVersaoAba(1);
    if (!finalizacao_ok && !pendente) {
      setFormularioFinalizacao({
        ...formularioFinalizacao,
        status_final: listaStatus.find(i => i.value === statusSugerido)
      });
      return setVersaoAba(2);
    }
    if (!finalizacao_ok && pendente) return setVersaoAba(3);
    if (finalizacao_ok) return setVersaoAba(4);
  }, [itemSelecionado]);

  useEffect(() => {
    // EXCLUSIVO PARA DESENVOLVIMENTO
    // if (statusSugerido === 4 && statusChecklist === 4) return setListaStatusFiltrada(listaStatus.filter(i => [5, 6, statusSugerido].includes(i.value)));
    // EXCLUSIVO PARA DESENVOLVIMENTO

    if (statusSugerido === 5 && statusChecklist === 4) return setListaStatusFiltrada(listaStatus.filter(i => [6, statusSugerido].includes(i.value)));
    if (statusSugerido === 5 && possuiDirecionamento2Q) return setListaStatusFiltrada(listaStatus.filter(i => [5, 6, statusSugerido].includes(i.value)));
    if (statusSugerido === 5) return setListaStatusFiltrada(listaStatus.filter(i => [5, 6, 7, statusSugerido].includes(i.value)));
    if (statusSugerido === 6 || statusSugerido === 7) return setListaStatusFiltrada(listaStatus.filter(i => [5, statusSugerido].includes(i.value)));
  }, []);

  return (
    <section className={styles.final_tab_wrapper}>
      {/* FINALIZAÇÃO INDISPONÍVEL */}
      {
        versaoAba === 1 &&
        <div className={styles.inner_tab_wrapper}>
          <TabInfoComp />
          {itemSelecionado.revisao_ok ? <div className={styles.success_text}>Etapa de revisão concluída</div> : <div className={styles.warn_text}>Etapa de revisão em aberto</div>}
          {itemSelecionado.conferencia_caixa_ok ? <div className={styles.success_text}>Etapa de romaneios concluída</div> : <div className={styles.warn_text}>Etapa de romaneios em aberto</div>}
          {itemSelecionado.analise_ok ? <div className={styles.success_text}>Etapa de análise concluída</div> : <div className={styles.warn_text}>Etapa de análise em aberto</div>}
          {!itemSelecionado.prova_de_roupa_ok && <div className={styles.warn_text}>Etapa de prova de roupa em aberto</div>}
        </div>
      }

      {/* NÃO FINALIZADO - NÃO PENDENCIADO */}
      {
        versaoAba === 2 &&
        <div className={styles.inner_tab_wrapper}>
          <TabInfoComp />
          <StatusSugerido />

          <div className={styles.separator} />

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center', width: '100%' }}>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', fontWeight: '500', color: '#000000AE' }}>
              <span>Pendente?</span>
              <Form.Check
                type={'switch'}
                style={{ fontWeight: '500', fontSize: '20px' }}
                onChange={() => setFormularioFinalizacao({
                  ...formularioFinalizacao,
                  pendente: !formularioFinalizacao.pendente,
                  status_final: !formularioFinalizacao.pendente ? null : listaStatus.find(obj => obj.value === statusSugerido),
                  atribuicao_pendenciado: null,
                  atribuicao_estilo: null
                })}
                checked={formularioFinalizacao.pendente}
                disabled={statusSugerido === 4}
              />

              <span>Indica Culpabilidade do Fornecedor?</span>
              <Form.Check
                type={'switch'}
                style={{ fontWeight: '500', fontSize: '20px' }}
                onChange={() => setFormularioFinalizacao({
                  ...formularioFinalizacao,
                  indica_culpabilidade: !formularioFinalizacao.indica_culpabilidade
                })}
                checked={formularioFinalizacao.indica_culpabilidade}
                disabled={
                  formularioFinalizacao.pendente
                  || ![6, 7].includes(statusSugerido)
                  || itemSelecionado.analiseDirecionamentos.some(item => item.descricao_destino.includes('%'))
                }
              />
            </div>

            <SelectInput
              label={'Atribuição Pendenciado'}
              style={{ width: '100%' }}
              value={formularioFinalizacao.atribuicao_pendenciado}
              onChange={e => setFormularioFinalizacao({ ...formularioFinalizacao, atribuicao_pendenciado: e, atribuicao_estilo: null })}
              options={listaPendenciaUm}
              isDisabled={!formularioFinalizacao.pendente}
            />

            <SelectInput
              label={'Justificativa Atribuição Estilo'}
              style={{ width: '100%' }}
              value={formularioFinalizacao.atribuicao_estilo}
              onChange={e => setFormularioFinalizacao({ ...formularioFinalizacao, atribuicao_estilo: e, responsavel_estilo: null })}
              options={listaPendenciaDois}
              isDisabled={!formularioFinalizacao.pendente || formularioFinalizacao.atribuicao_pendenciado?.value !== 1}
            />
          </div>
        </div>
      }

      {/* NÃO FINALIZADO - PENDENCIADO */}
      {
        versaoAba === 3 && !isAdmin && !usuarioGestaoFup &&
        <div className={styles.inner_tab_wrapper}>
          <div className={styles.warn_text}>Produção pendente decisão da gestão</div>
        </div>
      }
      {
        versaoAba === 3 && (isAdmin || usuarioGestaoFup) &&
        <div className={styles.inner_tab_wrapper}>
          <TabInfoComp />
          <StatusSugerido />

          <div className={styles.separator} />

          <SelectInput
            label={'Status Final Checklist'}
            style={{ width: '100%' }}
            value={formularioFinalizacao.status_final}
            onChange={e => {
              setFormularioFinalizacao({
                ...formularioFinalizacao,
                status_final: e,
                novo_direcionamento: null,
                indica_culpabilidade: itemSelecionado.analiseDirecionamentos.some(item => item.descricao_destino.includes('%')) ? true : false
              })
            }}
            options={listaStatusFiltrada}
          />

          <span style={{ fontWeight: '500', color: '#000000AE' }}>Indica Culpabilidade do Fornecedor?</span>
          <Form.Check
            type={'switch'}
            style={{ fontWeight: '500', fontSize: '20px' }}
            onChange={() => setFormularioFinalizacao({
              ...formularioFinalizacao,
              indica_culpabilidade: !formularioFinalizacao.indica_culpabilidade
            })}
            checked={formularioFinalizacao.indica_culpabilidade}
            disabled={
              (![6, 7].includes(formularioFinalizacao.status_final?.value))
              || itemSelecionado.analiseDirecionamentos.some(item => item.descricao_destino.includes('%'))
            }
          />

          {
            (itemSelecionado.id_justificativa_pendencia === 3 || itemSelecionado.id_justificativa_pendencia === 4) &&
            <div style={{ width: '100%' }}>
              <label style={{ marginBottom: '4px', fontWeight: '500', color: '#000000AE' }}>Responsável Estilo</label>
              <Form.Control
                type={'text'}
                value={formularioFinalizacao.responsavel_estilo || ''}
                onChange={e => setFormularioFinalizacao({ ...formularioFinalizacao, responsavel_estilo: e.target.value })}
                placeholder={'Responsável Estilo'}
                style={{ width: '100%', height: '38px' }}
              />
            </div>
          }

          <SelectInput
            label={'Novo direcionamento para peças previamente direcionadas à estoques de 1ª qualidade (opcional)'}
            style={{ width: '100%' }}
            value={formularioFinalizacao.novo_direcionamento || null}
            onChange={e => setFormularioFinalizacao({ ...formularioFinalizacao, novo_direcionamento: e })}
            options={listaDestino}
            isClearable={true}
            isDisabled={
              !formularioFinalizacao?.status_final
              ||
              ((statusSugerido === formularioFinalizacao?.status_final?.value) && formularioFinalizacao.status_final?.value !== 5)
              ||
              formularioFinalizacao.status_final?.value !== 5
            }
          />
        </div>
      }

      {/* FINALIZADO */}
      {
        versaoAba === 4 &&
        <div className={styles.inner_tab_wrapper}>
          <TabInfoComp />
        </div>
      }

      <section
        className={styles.info_obs_wrapper}
        style={{ display: versaoAba !== 1 ? 'flex' : 'none' }}
      >
        <Form.Group>
          <Form.Label style={{ fontWeight: '500' }}>Observações da Analista Checklist</Form.Label>
          <Form.Control
            as={'textarea'}
            placeholder={'Insira aqui quaisquer observações adicionais sobre a finalização do controle de qualidade.'}
            rows={6}
            value={formularioFinalizacao.observacoes_analista || ''}
            onChange={e => setFormularioFinalizacao({ ...formularioFinalizacao, observacoes_analista: e.target.value })}
            disabled={!itemSelecionado.revisao_ok || !itemSelecionado.conferencia_caixa_ok || !itemSelecionado.analise_ok || !itemSelecionado.prova_de_roupa_ok || itemSelecionado.finalizacao_ok}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label style={{ fontWeight: '500' }}>Orientações para conserto (campo visível ao fornecedor)</Form.Label>
          <Form.Control
            as={'textarea'}
            placeholder={'Insira aqui quaisquer orientações para conserto, caso existam.'}
            rows={6}
            value={formularioFinalizacao.orientacoes_conserto || ''}
            onChange={e => setFormularioFinalizacao({ ...formularioFinalizacao, orientacoes_conserto: e.target.value })}
            disabled={!itemSelecionado.revisao_ok || !itemSelecionado.conferencia_caixa_ok || !itemSelecionado.analise_ok || !itemSelecionado.prova_de_roupa_ok || itemSelecionado.finalizacao_ok}
          />
        </Form.Group>
      </section>
    </section >
  );
}

export default PAChecklistFollowUpFinalTab;
